export namespace SortingQuestion {
  export const type = 'sortingQuestion';
  export interface Answer {
    order: string[];
    modifiedAt: number;
  }

  export interface AnswerResult {
    type: 'correct' | 'incorrect';
  }
}
